/**
 * Copyright (c) Omnissa, LLC. All rights reserved.
 * This product is protected by copyright and intellectual property laws in the
 * United States and other countries as well as by international treaties.
 * -- Omnissa Restricted
 *
 * @format
 */

import { Injectable } from "@angular/core";
import { SharedWorkerChannelService } from "./utils/shared-worker-channel.service";

@Injectable()
export class MergeChannelService extends SharedWorkerChannelService {
   private messageQueue: Array<{ targetId: string; type: string; data: any }> = [];

   constructor() {
      super();
   }

   async initialize(): Promise<void> {
      await this.waitUntilReady();
      this.processMessageQueue();
   }

   async sendHandover(targetId: string, data: any): Promise<void> {
      if (!this.getConnectionId()) {
         this.messageQueue.push({ targetId, type: "handover", data });
         return;
      }
      await this.sendRawMessage("handover", data, targetId);
   }

   async sendHandoverAck(targetId: string, data: any): Promise<void> {
      if (!this.getConnectionId()) {
         this.messageQueue.push({ targetId, type: "handover-ack", data });
         return;
      }
      await this.sendRawMessage("handover-ack", data, targetId);
   }

   async sendNotification(data: any): Promise<void> {
      if (!this.getConnectionId()) {
         this.messageQueue.push({ targetId: "", type: "notification", data });
         return;
      }
      await this.sendRawMessage("notification", data);
   }

   private processMessageQueue(): void {
      if (this.messageQueue.length === 0) return;

      const queueCopy = [...this.messageQueue];
      this.messageQueue = [];

      for (const message of queueCopy) {
         if (message.type === "handover") {
            this.sendHandover(message.targetId, message.data).catch((error) =>
               this.logger.error("Failed to process queued handover:" + error)
            );
         } else if (message.type === "handover-ack") {
            this.sendHandoverAck(message.targetId, message.data).catch((error) =>
               this.logger.error("Failed to process queued handover-ack:" + error)
            );
         } else if (message.type === "notification") {
            this.sendNotification(message.data).catch((error) =>
               this.logger.error("Failed to process queued notification:" + error)
            );
         }
      }
   }
}
